<div class="general-container">
    <mat-toolbar>
        <mat-toolbar-row>
            <a href="https://www.co-assist.fr">
                <img class="logo-header" src="/assets/images/logos/co-assist/Co-assist-logo-2.png"
                    srcset="/assets/images/logos/co-assist/Co-assist-vector.svg" alt="Logo co-assist">
            </a>
            <span class="example-spacer"></span>
            <app-multilingual class="multilingual-placement"></app-multilingual>
        </mat-toolbar-row>
    </mat-toolbar>
    <div class="row">
        <div class="titre">
            <b>
                <h3>
                    <div *ngIf="successful; else responseTitle">
                        {{'REGISTRATION.STEP.PAYMENT.RESULT.SUCCESS' | translate}}
                    </div>
                    <ng-template #responseTitle>
                        {{'REGISTRATION.STEP.PAYMENT.RESULT.FAILURE' | translate}}
                    </ng-template>
                </h3>
            </b>
        </div>
        <div class="main-frame">
            <div *ngIf="isLoading(); else response">
                <app-loading></app-loading>
            </div>
            <ng-template #response>
                <div *ngIf="successful; else error">
                    <div class="center">
                        <mat-icon class="done">done</mat-icon>
                        <h4>{{'REGISTRATION.STEP.PAYMENT.DIALOG_PAYMENT.SUCCESS' | translate}}</h4>
                        <button mat-raised-button color="primary" class="color-btn buttonClass"
                            onclick="location.href='/#/login'">{{'LOGIN.LOGIN_BUTTON' | translate}}</button>
                    </div>
                </div>
                <ng-template #error>
                    <div class="center">
                        <mat-icon class="fail">clear</mat-icon>
                        <h4>{{'REGISTRATION.STEP.PAYMENT.DIALOG_PAYMENT.ERROR.MESSAGE' | translate}}</h4>
                        <button mat-raised-button color="primary" class="color-btn buttonClass"
                            onclick="location.href='/#/subscription'">{{'REGISTRATION.STEP.PAYMENT.DIALOG_PAYMENT.REDIRECT_PAYMENT_PAGE'
                            | translate}}</button>
                    </div>
                </ng-template>
            </ng-template>
        </div>
    </div>
</div>